import { CircularProgress, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { MessageKey } from '../i18n';
import { TranslatedText } from './TranslatedText';

interface LoadingBlockProps {
  messageKey?: MessageKey;
  py?: number;
  size?: number;
}

const LoadingRow = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'verticalPadding',
})<{ verticalPadding: number }>(({ theme, verticalPadding }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1.5),
  paddingBlock: theme.spacing(verticalPadding),
}));

export function LoadingBlock({ messageKey, py = 4, size = 22 }: LoadingBlockProps) {
  return (
    <LoadingRow verticalPadding={py}>
      <CircularProgress size={size} />
      {messageKey ? (
        <TranslatedText messageKey={messageKey} variant="body2" color="text.secondary" />
      ) : null}
    </LoadingRow>
  );
}
